import axios from 'axios';
import auth from './api/auth';

window.axios = axios;

// Set default headers
const headers = {
  Accept: 'application/json',
};

// Configure axios API instance
window.api = axios.create({
  baseURL: process.env.API_URL,
  headers,
});

// Request interseptor
api.interceptors.request.use((config) => {
  if (auth.isAuthenticated()) {
    config.headers.Authorization = `Bearer ${auth.getToken()}`;
  }

  return config;
}, error => Promise.reject(error));

// Response interseptor
api.interceptors.response.use(response => response,
  (error) => {
    if (error.response !== undefined) {
      if (error.response.status === 401 && auth.isAuthenticated()) {
        auth.logout();
        location.reload();
      }

      if (error.response.data.message !== undefined) {
        vm.$children[0].snackbar(error.response.data.message);
      }
    }

    return Promise.reject(error);
  });



// WEBPACK FOOTER //
// ./src/js/http.js